export default [
  {
    title: 'منابع انسانی',
    icon: 'UsersIcon',
    children: [
      {
        title: 'ورود و خروج',
        icon: 'Edit3Icon',
        route: 'Attendance_List',
        permission: 'attendances.index',
      },{
        title: 'مانده مرخصی',
        icon: 'Edit3Icon',
        route: 'Update_Vacation',
        permission: 'remainVacation',
      },
    ],
  },
]
